import React, { useState, useContext, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import DarkModeContext from "../../store/DarkModeContext";
import { lightModeColors, darkModeColors } from "../../utils/colors";
import { useTranslation } from "react-i18next";
import Page from "../DefaultPage/DefaultPage";
import PopupContext from "../../store/PopupContext";

const Live_Map = (props) => {
  const [tg, i18] = useTranslation("global");
  const [clickedLocation, setClickedLocation] = useState(props.location);
  const [showPolicy, setShowPolicy] = useState(false);
  const { darkMode } = useContext(DarkModeContext);
  const { textColor, backgroundColor, cardColor } = darkMode ? darkModeColors : lightModeColors;
  const { popupIsOpened } = useContext(PopupContext);

  // Estado para detectar se é mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Atualiza isMobile ao redimensionar janela
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const MapClickHandler = () => {
    useMapEvents({
      click: (e) => {
        const { lat, lng } = e.latlng;
        setClickedLocation([lat, lng]);
        props.onLocationClick([lat, lng]);
      },
    });
    return null;
  };

  const customIcon = new L.Icon({
    iconUrl:
      process.env.PUBLIC_URL +
      "/images/png-transparent-tracker-map-indicator-pointer-pin-position-location-green-thumbnail-removebg-preview.png",
    iconSize: [22, 22],
    iconAnchor: [11, 22],
    popupAnchor: [0, -22],
  });

  return (
    <Page>
      <div style={{ position: "relative" }}>
        {!popupIsOpened && (
          <>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "80px", marginLeft: "80px", width:"300px" }}>
              <p>{tg("global.map.clickPointsExplanation")}</p>
            </div>

            {/* Container externo com largura 100vw e alinhamento flex-start no mobile */}
            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "flex-start" : "center",
                marginTop: "10px",
                width: "100vw",
                paddingLeft: isMobile ? "10px" : "0",
              }}
            >
              <MapContainer
                center={
                  isMobile
                    ? [40.205681041909216, -8.417621614644306]
                    : [40.203913474032575, -8.407841054062924]
                }
                zoom={13.5}
                style={{
                  height: isMobile ? "70vh" : "80vh",
                  width: isMobile ? "93vw" : "80vw",
                }}
              >
                <MapClickHandler />
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {props.objectiveCoordinates?.map(
                  (coord, index) =>
                    coord?.lat &&
                    coord?.lng && (
                      <Marker key={index} position={[coord.lat, coord.lng]} icon={customIcon}>
                        <Popup>
                          Objetivo: {coord.title}
                          <br />
                          Descrição: {coord.description}
                          <br />
                          Direções:{" "}
                          <a
                            href={`https://www.google.com/maps/dir/?api=1&destination=${coord.lat},${coord.lng}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Abrir no Google Maps
                          </a>
                        </Popup>
                      </Marker>
                    )
                )}
              </MapContainer>
            </div>
          </>
        )}
      </div>
    </Page>
  );
};

export default Live_Map;
